<template>
  <section class="page-dashbord-messages pt-4">
    <app-loading :isFull="true" v-if="isLoading" />
    <div class="container">
      <div class="col-12">
        <header class="text-right mb-4">
          <h1 class="font-20">پیام های دوره</h1>
        </header>
      </div>
      <div class="wrapper-form row shadow py-4 mb-5">
        <div class="col-6">
          <div class="group-form">
            <textarea
              type="text"
              v-validate="'required'"
              name="wlc_msg"
              :class="{active:msgs.wlc_msg != '' }"
              v-model="msgs.wlc_msg"
            ></textarea>
            <span class="bar"></span>
            <label class="statr">پیام خوش آمد گویی</label>
            <span v-if="errors.has('wlc_msg')" class="is-danger">فیلد نباید خالی باشد</span>
          </div>
        </div>
        <div class="col-6">
          <div class="group-form">
            <textarea
              type="text"
              v-validate="'required'"
              name="finish_msg"
              :class="{active:msgs.finish_msg != '' }"
              v-model="msgs.finish_msg"
            ></textarea>
            <span class="bar"></span>
            <label class="statr">پیام اتمام دوره</label>
            <span v-if="errors.has('finish_msg')" class="is-danger">فیلد نباید خالی باشد</span>
          </div>
        </div>
        <div class="col-12">
          <div class="form-action text-left">
            <button
              v-if="!msgs.id"
              class="font-16 px-5 py-2 bttn-fill bttn bttn-success"
              v-ripple
              @click="saveMsg"
            >تایید نهایی و ارسال</button>
            <button
              v-else
              class="font-16 px-5 py-2 bttn-fill bttn bttn-success"
              v-ripple
              @click="updateMsg"
            >بروزرسانی پیام ها</button>
          </div>
        </div>
        <div class="col-12">
          <controller-curose></controller-curose>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "page-dashbord-messages",
  data() {
    return {
      isLoading: false,
      msgs: {
        wlc_msg: "",
        finish_msg: ""
      }
    };
  },
  mounted() {
    if (localStorage && !this.hasCourse().id) {
      this.$root.showWarnMsg({
        message: "شما دوره ی جدیدی تعریف نکرده اید ..."
      });
      this.$router.push({ name: "courseForm" });
      return;
    }
    this.getMsg();
  },
  methods: {
    async getMsg() {
      try {
        let { data } = await axios.post("/course-msg/get", {
          course_id: this.hasCourse().id
        });
        if (data.state !== 200) return;
        if (data.msgs.length > 0) {
          this.msgs = data.msgs[0];
        }
      } catch (error) {
        console.log(error);
      }
    },
    async saveMsg() {
      let result = await this.$validator.validate();
      if (!result) {
        this.$root.showWarnMsg({
          message: "لطفا فرم را تکمیل کنید ... "
        });
        return;
      }
      try {
        this.isLoading = true;
        let body = {
          course: parseInt(this.hasCourse().id),
          finish_msg: this.msgs.finish_msg,
          wlc_msg: this.msgs.wlc_msg
        };
        let { data } = await axios.post("/course-msg/new", body);
        this.isLoading = false;
        if (data.state !== 200) return;
        this.$store.commit(
          "notifications/success",
          { message: this.$t("message.request.done"), title: "" },
          { root: true }
        );
        this.$router.push("/dashboard/mycourses");
        this.removeCourseId();
      } catch (error) {
        console.log(error);
      }
      this.isLoading = false;
    },
    async updateMsg() {
      let result = await this.$validator.validate();
      if (!result) {
        this.$root.showWarnMsg({
          message: "لطفا فرم را تکمیل کنید ... "
        });
        return;
      }
      try {
        this.isLoading = true;
        let body = {
          course_id: parseInt(this.hasCourse().id),
          finish_msg: this.msgs.finish_msg,
          wlc_msg: this.msgs.wlc_msg
        };
        let { data } = await axios.post("/course-msg/update", body);
        this.isLoading = false;
        if (data.state !== 200) return;
        this.$store.commit(
          "notifications/success",
          { message: this.$t("message.request.done"), title: "" },
          { root: true }
        );
        this.removeCourseId();
        this.$router.push("/dashboard/mycourses");
      } catch (error) {
        this.$store.commit(
          "notifications/error",
          { message: this.$t("message.request.someProblem"), title: "" },
          { root: true }
        );
        console.log(error);
      }
      this.isLoading = false;
    }
  }
};
</script>

<style lang="less">
@import (reference) "../../assets/css/variable.less";
.page-dashbord-messages {
  .box-clear;
}
</style>



// WEBPACK FOOTER //
// src/pages/dashboard/messages.vue